import React, { useEffect } from 'react';

export default function ChatPage() {
  useEffect(() => {
    const scriptId = 'amazon-connect-script';
    if (document.getElementById(scriptId)) {
      window.amazon_connect?.('openChat');
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = scriptId;

    script.innerHTML = `
      (function(w, d, x, id){
        s=d.createElement('script');
        s.src='https://d1ddlw7p7j6hta.cloudfront.net/amazon-connect-chat-interface-client.js';
        s.async=1;
        s.id=id;
        d.getElementsByTagName('head')[0].appendChild(s);
        w[x] = w[x] || function() {
          (w[x].ac = w[x].ac || []).push(arguments);
        };
      })(window, document, 'amazon_connect', '944f2297-94a7-4f26-b919-5fab0918f79b');
      
      amazon_connect('styles', {
        openChat: { color: 'white', backgroundColor: '#10d4a4' },
        closeChat: { color: 'white', backgroundColor: '#10d4a4' }
      });

      amazon_connect('snippetId', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NDgwODEyNzMsImVtYWlsIjoibmlzaGEubXVydWdlc2FuQGFnYW50aXMudGVhbSIsInJvbGUiOm51bGwsIm5hbWUiOiJOaXNoYSBNdXJ1Z2VzYW4ifQ.297oke50gCSUTc25Ozgupu5U06_Q_LTronJicxVlqNs');

      amazon_connect('openChat');
    `;

    document.body.appendChild(script);
  }, []);

  return (
    <div style={{ padding: 40 }}>
      <h1>Live Chat</h1>
      <p>This page will auto-load and open the Amazon Connect chat.</p>
    </div>
  );
}


